import { createSlice } from "@reduxjs/toolkit";
import { DriverMileageDto } from "../entities/dtos/driver-mileage.dto";
import getDriverMileageCases from "./cases/get-driver-mileage.cases";

export interface IDriverMileageState {
  loading: boolean;
  driverMileageList: DriverMileageDto[];
  totalRecords: number;
}

const initialState: IDriverMileageState = {
  loading: false,
  driverMileageList: [],
  totalRecords: 0
};

const driverMileageSlice = createSlice({
  name: "driverMileage",
  initialState,
  reducers: {
    resetDriverMileageState: () => initialState
  },
  extraReducers: (builder) => {
    getDriverMileageCases(builder);
  }
});

export const { resetDriverMileageState } = driverMileageSlice.actions;
export default driverMileageSlice.reducer;
